module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA6BAMAAAC0SOHgAAAAD1BMVEUAAAD/+wD/+wD/+wD/+wCqS7SMAAAABHRSTlMAVtTWUUZDYgAAAF5JREFUSMft1LENwEAIA0CzAcWPwAi/wBPvP1MWACmQIkW43pLdGGKMuCK1GDtIGWOOFDPNSL/Y+/myGbkUY4xviLHEFYtFB8YiB8sakUaxznzZzMwnjvHEXN8/ru8Gbt8ET4snOhYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/main_click_2.png
// module id = OwJi
// module chunks = 1